/**
 * components util
 */

/**
 * Clean up null objects
 * @param children
 * @returns {*[]}
 */
export function filterEmpty (children = []) {
  return children.filter(c => c.tag || (c.text && c.text.trim() !== ''))
}

/**
 * Get length of string
 * @param {*} str
 */
export const getStrFullLength = (str = '') =>
  str.split('').reduce((pre, cur) => {
    return pre + 1
  }, 0)

/**
 * @param {*} str
 * @param {*} maxLength
 */
export const cutStrByFullLength = (str = '', maxLength) => {
  let showLength = 0
  return str.split('').reduce((pre, cur) => {
    showLength += 1
    if (showLength <= maxLength) {
      return pre + cur
    }
    return pre
  }, '')
}
